import React from "react";
import { Dialog, DialogContent, Box, Typography, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const ApproveModal = ({ open, onClose, onConfirm, employeeName = "Amila Bandara" }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          padding: { xs: "20px 16px", sm: "24px 20px" },
          maxWidth: "360px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
        },
      }}
    >
      <DialogContent sx={{ p: 0, display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* Green Check Icon Circle */}
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: "#22C55E",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            mb: 2,
            boxShadow: "0 6px 16px rgba(34, 197, 94, 0.3)",
          }}
        >
          <CheckIcon sx={{ fontSize: 32, stroke: "#ffffff", strokeWidth: 1 }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "#1E293B",
            fontSize: "1.2rem",
            mb: 1.2,
          }}
        >
          Confirm Approval
        </Typography>

        {/* Confirmation Question */}
        <Typography
          sx={{
            color: "#475569",
            fontSize: "0.95rem",
            lineHeight: 1.5,
            mb: 3,
            px: 1,
          }}
        >
          Are you sure you want to approve this travel request for{" "}
          <Box component="span" sx={{ fontWeight: 700, color: "#0F172A" }}>
            {employeeName}
          </Box>
          ?
        </Typography>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", width: "100%", gap: 1.5 }}>
          <Button
            fullWidth
            onClick={onClose}
            variant="text"
            sx={{
              backgroundColor: "#F1F5F9",
              color: "#334155",
              fontWeight: 600,
              fontSize: "0.95rem",
              textTransform: "none",
              borderRadius: "12px",
              py: 1.2,
              "&:hover": {
                backgroundColor: "#E2E8F0",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            onClick={onConfirm}
            variant="contained"
            sx={{
              backgroundColor: "#16A34A",
              color: "#ffffff",
              fontWeight: 600,
              fontSize: "0.95rem",
              textTransform: "none",
              borderRadius: "12px",
              py: 1.2,
              boxShadow: "0 4px 12px rgba(22, 163, 74, 0.25)",
              "&:hover": {
                backgroundColor: "#15803D",
              },
            }}
          >
            Approve
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveModal;
